'use client'

import React from 'react'
import error404Img from './../../assets/images/404.svg'

import { Card, CardBody, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
const NotFound = () => {
  const logoSrc = `${process.env.PUBLIC_URL}/filter_market_logo_transparente.png`

  return (
    <>
      <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col xl={6}>
              <Card className="auth-card">
                <CardBody className="p-0">
                  <Row className="align-items-center g-0">
                    <Col>
                      <div className="p-4">
                        <div className="mx-auto mb-4 text-center">
                          <div className="mx-auto text-center auth-logo">
                            <Link to="/oracle" className="logo-dark">
                              <img src={logoSrc} height={40} alt="Filter Market" />
                            </Link>
                            <Link to="/oracle" className="logo-light">
                              <img src={logoSrc} height={40} alt="Filter Market" />
                            </Link>
                          </div>
                          <img src={error404Img} alt="auth" height={250} className="mt-5 mb-3" />
                          <h2 className="fs-22 lh-base">Page Not Found !</h2>
                          <p className="text-muted mt-1 mb-4">
                            The page you&apos;re trying to reach seems to have gone <br /> missing in the digital wilderness.
                          </p>
                          <div className="text-center">
                            <Link to="/oracle" className="btn btn-dark">
                              Back to Home
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
export default NotFound
